import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/site/Reveal";

export const SafePlaceTeaser = () => (
  <section data-testid="safe-place-teaser" className="bg-gum px-5 py-24 text-sand sm:px-10 lg:py-32">
    <div className="mx-auto grid max-w-[1440px] items-center gap-12 lg:grid-cols-12">
      <Reveal className="lg:col-span-6">
        <p className="eyebrow text-amber">Safe Place</p>
        <h2 className="mt-5 font-display text-5xl font-medium leading-[0.95] tracking-tight sm:text-7xl">Somewhere to <span className="italic">yarn</span>, heal and belong.</h2>
        <p className="mt-6 max-w-lg text-sand/85 md:text-lg">Family and domestic violence support, safe housing for women and children, safe transport to school, family and appointments, mental health support, counselling, food hampers and art therapy — drop in, or request support privately. In crisis? Call 13YARN on 13 92 76, any time.</p>
        <ul className="mt-8 flex flex-wrap gap-2">
          {["Domestic violence support", "Safe housing", "Safe transport", "Mental health", "Counselling", "Food hampers", "Art therapy"].map((t) => (
            <li key={t} className="rounded-full border border-sand/30 px-4 py-1.5 font-mono text-[11px] uppercase tracking-[0.15em]">{t}</li>
          ))}
        </ul>
        <div className="mt-10 flex flex-wrap gap-4">
          <Link to="/safe-place" data-testid="teaser-safe-place-button" className="btn-ochre group">Visit Safe Place <ArrowUpRight className="h-4 w-4 transition-transform group-hover:rotate-45" /></Link>
          <a href="tel:139276" data-testid="teaser-13yarn-link" className="btn-line border-sand/40 text-sand hover:bg-sand hover:text-ink">Call 13YARN</a>
        </div>
      </Reveal>
      <Reveal delay={0.15} className="lg:col-span-5 lg:col-start-8">
        <div className="h-80 overflow-hidden rounded-[200px_200px_28px_28px] sm:h-[460px]">
          <img src="/img/headland.jpg" alt="Calm ocean view from a green headland" className="h-full w-full object-cover" />
        </div>
      </Reveal>
    </div>
  </section>
);
